import styled from 'styled-components';
import media from '../../../constants/media';
import theme from '../../../constants/theme';

export const Wrapper = styled.div``;

export const InputField = styled.input`
	display: flex;
	align-items: center;
	padding: 8px 8px 8px 32px;
	width: 100%;
	height: 72px;
	font-weight: ${theme.fonts.weight.regular};
	font-size: 18px;
	line-height: 1.5;
	color: ${theme.colorsV2.mainDark};
	border: 2px solid ${theme.colors.white};
	background: ${theme.colors.white};
	box-shadow: 0 4px 40px rgba(0, 0, 0, 0.08);
	border-radius: 16px;
	transition: border-color 100ms ease-in-out;

	${media.tablet`
		height: 80px;
		font-size: 22px;
		padding: 8px 77px 8px 32px;
	`}

	&::placeholder {
		color: ${theme.colorsV2.grey6};
	}

	&:focus,
	&:hover {
		border-color: ${theme.colorsV2.grey5};
	}
`;

export const InputMenu = styled.ul`
	position: absolute;
	z-index: 1;
	top: 88px;
	left: 0;
	width: 100%;
	background: ${theme.colors.white};
	max-height: 408px;
	overflow: auto;
	padding: 2.5rem 0;
	box-shadow: 0 0 30px rgba(0, 0, 0, 0.08);
	border-radius: 8px;

	&:empty {
		display: none;
	}
`;

export const InputItem = styled.li`
	list-style-type: none;
	padding: 12px 24px;
	color: ${theme.colorsV2.mainDark};
	font-size: 18px;
	cursor: pointer;
	transition: color 150ms;
	background: ${theme.colors.white};

	&:hover {
		background-color: ${theme.colorsV2.grey2};
	}
`;

export const InputContainer = styled.div``;
